import { api } from './api';

export const fetchDocuemntsById = (params) => {
  return api.get('/document', params);
};

export const fetchUpdateDocument = (id, payload) => {
  return api.put(`/document/${id}`, payload);
};

export const fetchUploadDocument = (payload) => {
  return api.post('/document/upload', payload, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

export const fetchVersionsByDocumentId = (id, params) => {
  return api.get(`/document/${id}/version`, params);
};

export const fetchDownloadDocument = (id) => {
  return api.get(
    `/document/insurance/user/${id}?filetype=png`,
    {},
    { responseType: 'arraybuffer' }
  );
};

// V2

export const createVersion = (documentId, formData, extraParams = {}) =>
  api.post(`/document/${documentId}/version`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
      ...extraParams,
    },
  });

export const createDocument = (data) => api.post('/document', data);

export const updateDocument = (documentId, data) => api.put(`/document/${documentId}`, data);

export const getVersion = (documentId, versionId) =>
  api.get(`/document/${documentId}/version/${versionId}`);

export const updateVersion = (documentId, versionId, formData, extraParams = {}) =>
  api.put(`/document/${documentId}/version/${versionId}`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
      ...extraParams,
    },
  });

export const fetchDocuments = (params, options) => api.get('/document', params, options);

export const fetchDocument = (id) => api.get(`/document/${id}`);

export const fetchVersion = (documentId, versionId) =>
  api.get(`/document/${documentId}/version/${versionId}`);

export const deleteVersionsFile = (documentId, versionId) =>
  api.delete(`/document/${documentId}/version/${versionId}/file`);

export const uploadVersionsFile = (documentId, versionId, formData, extraParams = {}) =>
  api.post(`/document/${documentId}/version/${versionId}/file`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
      ...extraParams,
    },
  });

export const deleteVersion = (documentId, versionId) =>
  api.delete(`/document/${documentId}/version/${versionId}`);

export const deleteDocument = (documentId) => api.delete(`/document/${documentId}`);

// Document types
export const fetchDocumentTypes = (params, options) =>
  api.get('/document/document_type', params, options);

export const createDocumentType = (payload) => api.post('/document/document_type', payload);

export const updateDocumentType = (id, payload) =>
  api.put(`/document/document_type/${id}`, payload);

export const fetchDocumentType = (id) => api.get(`/document/document_type/${id}`);

export const deleteDocumentType = (id) => api.delete(`/document/document_type/${id}`);
